import { render, staticRenderFns } from "./bet.vue?vue&type=template&id=3042970d&"
import script from "./bet.vue?vue&type=script&lang=js&"
export * from "./bet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports